import * as globalConfig from 'globalConfig';
import { BasketCountAndExpiryModel } from 'Content/ts/Models/UniversalBasket/BasketCountAndExpiryModel';

class UniversalBasketService {

    private getBasketCountAndExpiry() {
        return $.ajax({
            type: 'GET',
            async: true,
            url: globalConfig.Urls.UniversalBasket.GetBasketCountAndExpiry,
        });
    }

    public getBasketCountAndExpiryAsync(): Promise<BasketCountAndExpiryModel> {
        return new Promise((resolve, reject) => this.getBasketCountAndExpiry().done(resolve).fail(reject));
    }
}

const service = new UniversalBasketService();
export { service as UniversalBasketService };
